module.exports = __webpack_public_path__ + "static/media/greenBin.08a06a89.svg";